import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_pos-r" }
const _hoisted_2 = { class: "gfu-card__media-wrapper" }
const _hoisted_3 = ["href", "title"]
const _hoisted_4 = { class: "gfu-project-card__stamps" }
const _hoisted_5 = ["href", "title"]
const _hoisted_6 = { class: "gfu-project-flip-card__stamp--right _gap-2" }
const _hoisted_7 = { class: "_pa-3 _grow-1 _flexcol _jc-sb" }
const _hoisted_8 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _mb-1 _mt-3" }
const _hoisted_9 = { class: "_ttu _tc--accent" }
const _hoisted_10 = {
  class: "gfu-hd gfu-hd--h3 _line-clamp-2 _mb-3",
  "data-qa": "project-card:ProjectName"
}
const _hoisted_11 = ["href", "title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_balloon_actions = _resolveComponent("balloon-actions")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, {
    theme: $props.theme,
    "data-qa": `project-card-ID:${$props.projectID}`
  }, {
    media: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            class: "gfu-embed gfu-embed--1x1",
            href: $props.url,
            title: $props.name
          }, [
            _createVNode(_component_base_image, {
              src: $props.imageUrl,
              alt: $props.name,
              class: "gfu-embed__item",
              loading: "lazy"
            }, null, 8 /* PROPS */, ["src", "alt"])
          ], 8 /* PROPS */, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              class: "_rounded--input _pa-h _flex _bxsh--base _bgc--white",
              href: $props.url,
              title: $props.creator.name
            }, [
              _createVNode(_component_base_image, {
                src: $props.creator.avatarUrl || $options.placeholderImageUrl,
                alt: $props.creator.name,
                width: 36,
                height: 36,
                loading: "lazy"
              }, null, 8 /* PROPS */, ["src", "alt"])
            ], 8 /* PROPS */, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          ($options.hasActions)
            ? (_openBlock(), _createBlock(_component_balloon_actions, {
                key: 0,
                actions: $props.actions,
                mode: $options.balloonActionsMode,
                "balloon-style-props": $options.balloonStyleProps,
                theme: "secondaryAlt",
                "data-qa": "project-card:Actions"
              }, null, 8 /* PROPS */, ["actions", "mode", "balloon-style-props"]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("strong", _hoisted_9, _toDisplayString($options.projectTypeLabel), 1 /* TEXT */)
          ]),
          _createElementVNode("h3", _hoisted_10, [
            _createElementVNode("a", {
              href: $props.url,
              title: $props.name
            }, _toDisplayString($props.name), 9 /* TEXT, PROPS */, _hoisted_11)
          ])
        ]),
        _createVNode(_component_base_button, {
          href: $props.url,
          tag: "a",
          title: $props.name,
          display: "block",
          theme: "accent"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.StoreCardButton), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href", "title"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["theme", "data-qa"]))
}